import classes from "./Tests.module.css";
import firstImage from "../../images/photos/nature/photo1.jpg";
import secondImage from "../../images/photos/nature/photo2.jpg";
import thirdImage from "../../images/photos/nature/photo3.jpg";
import forthImage from "../../images/photos/nature/photo4.jpg";
import CarouselComponent from "../../Components/UI/Carousel/Carousel";
import Slider from "@mui/material/Slider";
import { useRef, useState } from "react";
import Textarea from "../../Components/UI/Textarea/Textarea";
import validate from "../../utils/validations/validate";

var items = [
  { id: "43asg543", src: firstImage },
  { id: "djesag", src: secondImage },
  { id: "hlg4", src: thirdImage },
  { id: "jfd54gdv", src: forthImage },
];

function valuetext(value) {
  return `${value}Rials`;
}

const Tests = () => {
  const [value, setValue] = useState([20, 37]);
  const [valuez, setValuez] = useState({ alo: "harkas", polo: null });
  const [formValidity, setFormValidity] = useState({
    polo: { isValid: true, msg: "" },
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const inputChangeHandler = (e) => {
    setValue((ps) => {
      const newS = [...ps];
      if (e.target.name === "first") {
        newS[0] = e.target.value;
      } else {
        newS[1] = e.target.value;
      }
      return newS;
    });
  };
  const handleChangez = (event) => {
    setValuez((ps) => ({ ...ps, [event.target.name]: event.target.value }));
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(() => {
      autoAdjustHeight(event);
    }, 300);
  };
  const autoAdjustHeight = (event) => {
    event.target.style.height = "auto";
    event.target.style.height = event.target.scrollHeight + "px";
  };
  const debounceTimeoutRef = useRef(null);
  const validateHandler = (e) =>
    setFormValidity((ps) => ({
      ...ps,
      [e.target.name]: validate(e.target.value, "mandatory"),
    }));

  return (
    <div className={classes.container}>
      <div className={classes.carouselContainer}>
        <CarouselComponent items={items} />
      </div>
      <div className={classes.sliderContainer}>
        <Slider
          getAriaLabel={() => "Price"}
          value={value}
          onChange={handleChange}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          //   step={1000}
          //   marks
          min={10}
          max={100}
          color="secondary"
        />
        <input name="first" value={value[0]} onChange={inputChangeHandler} />
        <input name="second" value={value[1]} onChange={inputChangeHandler} />
      </div>
      <div className={classes.textareaContainer}>
        <textarea
          name="alo"
          value={valuez.alo}
          onChange={(e) => {
            handleChangez(e);
            // autoAdjustHeight(e);
          }}
          className={classes.textarea}
        />
      </div>
      <div className={classes.textareaContainer}>
        <Textarea
          value={valuez.polo}
          label="یادگاری"
          name="polo"
          onChange={(name, value) => setValuez((ps) => ({ ...ps, [name]: value }))}
          validityName={formValidity.polo}
          onBlur={validateHandler}
          disabled={true}
        />
      </div>
    </div>
  );
};

export default Tests;
